import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FaHome, FaBriefcase, FaTools, FaProjectDiagram, FaEnvelope, FaFileAlt, FaHandsHelping, FaPen } from 'react-icons/fa';
import './Navbar.css';
import navLogo from '../images/Dev-Ambani-logo.png';
import blueImage from '../images/blue.png';

const Navbar: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const profileImage = location.state?.profileImage || blueImage;
  const pathname = location.pathname;

  const isActive = (path: string) => {
    if (path === '/profile/recruiter') return pathname.startsWith('/profile');
    return pathname === path;
  };

  const handleScroll = () => {
    setIsScrolled(window.scrollY > 80);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  return (
    <>
      <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
        <div className="navbar-left">
          <Link to="/" className="navbar-logo">
            <img src={navLogo} alt="Dev Ambani" />
          </Link>
          <ul className="navbar-links">
            <li><Link to="/profile/recruiter" className={isActive('/profile/recruiter') ? 'nav-active' : ''}>Home</Link></li>
            <li><Link to="/projects" className={isActive('/projects') ? 'nav-active' : ''}>Projects</Link></li>
            <li><Link to="/work-experience" className={isActive('/work-experience') ? 'nav-active' : ''}>Experience</Link></li>
            <li><Link to="/publications" className={isActive('/publications') ? 'nav-active' : ''}>Publications</Link></li>
            <li><Link to="/recommendations" className={isActive('/recommendations') ? 'nav-active' : ''}>Recommendations</Link></li>
            <li><Link to="/blogs" className={isActive('/blogs') ? 'nav-active' : ''}>Blog</Link></li>
            <li><Link to="/skills" className={isActive('/skills') ? 'nav-active' : ''}>Skills</Link></li>
            <li><Link to="/contact-me" className={isActive('/contact-me') ? 'nav-active' : ''}>Hire Me</Link></li>
          </ul>
        </div>
        <div className="navbar-right">
          {/* Hamburger menu for mobile */}
          <div className="hamburger" onClick={toggleSidebar}>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <img src={profileImage} alt="Profile" className="profile-icon" onClick={() => { navigate('/browse') }} />
        </div>
      </nav>

      {/* Sidebar Overlay */}
      <div className={`sidebar-overlay ${isSidebarOpen ? 'open' : ''}`} onClick={closeSidebar}></div>

      {/* Sidebar (only visible on mobile) */}
      <div className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-logo">
          <img src={navLogo} alt="Dev Ambani" />
        </div>
        <ul>
          <li><Link to="/profile/recruiter" onClick={closeSidebar} className={isActive('/profile/recruiter') ? 'nav-active' : ''}><FaHome /> Home</Link></li>
          <li><Link to="/projects" onClick={closeSidebar} className={isActive('/projects') ? 'nav-active' : ''}><FaProjectDiagram /> Projects</Link></li>
          <li><Link to="/work-experience" onClick={closeSidebar} className={isActive('/work-experience') ? 'nav-active' : ''}><FaBriefcase /> Experience</Link></li>
          <li><Link to="/publications" onClick={closeSidebar} className={isActive('/publications') ? 'nav-active' : ''}><FaFileAlt /> Publications</Link></li>
          <li><Link to="/recommendations" onClick={closeSidebar} className={isActive('/recommendations') ? 'nav-active' : ''}><FaHandsHelping /> Recommendations</Link></li>
          <li><Link to="/blogs" onClick={closeSidebar} className={isActive('/blogs') ? 'nav-active' : ''}><FaPen /> Blog</Link></li>
          <li><Link to="/skills" onClick={closeSidebar} className={isActive('/skills') ? 'nav-active' : ''}><FaTools /> Skills</Link></li>
          <li><Link to="/contact-me" onClick={closeSidebar} className={isActive('/contact-me') ? 'nav-active' : ''}><FaEnvelope /> Hire Me</Link></li>
        </ul>
      </div>
    </>
  );
};

export default Navbar;
